import { JSX } from 'react'

import { IconProps } from '../../icon'

const Close: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2571 34.8845C11.5628 34.1902 11.5628 33.0646 12.2571 32.3703L32.3703 12.2571C33.0646 11.5628 34.1902 11.5628 34.8845 12.2571C35.5788 12.9514 35.5788 14.077 34.8845 14.7712L14.7712 34.8845C14.077 35.5788 12.9514 35.5788 12.2571 34.8845Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2571 12.2571C12.9514 11.5628 14.077 11.5628 14.7712 12.2571L34.8845 32.3703C35.5788 33.0646 35.5788 34.1902 34.8845 34.8845C34.1902 35.5788 33.0646 35.5788 32.3703 34.8845L12.2571 14.7712C11.5628 14.077 11.5628 12.9514 12.2571 12.2571Z'
      fill='black'
    />
  </svg>
)

export default Close
